import moment from "@/utils/moment";
import accountHelper from "@/utils/helpers/account";

const STATES = {
  created: {
    icon: "/static/icon_order_status_alert.svg",
    name: "criado",
    color: "primary"
  },
  requested_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    name: "criando dependências",
    color: "warning"
  },
  created_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    name: "aguardando pagamento",
    color: "warning"
  },
  payment_requested: {
    icon: "/static/icon_order_status_alert.svg",
    name: "pagamento solicitado",
    color: "warning"
  },
  waiting_payment: {
    icon: "/static/icon_order_status_alert.svg",
    name: "aguardando pagamento",
    color: "warning"
  },
  paid: {
    icon: "/static/icon_order_status_ok.svg",
    name: "pago",
    color: "success"
  },
  active: {
    icon: "/static/icon_order_status_ok.svg",
    name: "ativo",
    color: "success"
  },
  ended: {
    icon: "/static/icon_order_status_ok.svg",
    name: "finalizado",
    color: "success"
  },
  cancelled: {
    icon: "/static/icon_order_status_canceled.svg",
    name: "cancelado",
    color: "disabled"
  }
};

const PAYMENT_STATES = [
  "created_on_gateway",
  "payment_requested",
  "waiting_payment"
];

const ORDER_PAYMENT_STATES = [
  "created_on_gateway",
  "payment_requested",
  "waiting_payment",
  "scheduled"
];

const CYCLE_CONFIRMED_STATUS = ["paid", "active", "ended"];

const SCHEDULE_EVENTS_STATES = ["booked"];

const getState = state => STATES[state] || null;

const isInPaymentStatus = status => PAYMENT_STATES.includes(status);

function isCycleOrdersOnPaymentStatus(cycle) {
  if (cycle.orders.length <= 0) return false;

  return cycle.orders.every(o => ORDER_PAYMENT_STATES.includes(o.status));
}

function isCycleOrdersEventsOnPaymentStatus(cycle) {
  if (cycle.orders.length <= 0) return false;

  return cycle.orders.every(o =>
    SCHEDULE_EVENTS_STATES.includes(o.schedule_event.status)
  );
}

const isConfirmed = cycle => {
  return CYCLE_CONFIRMED_STATUS.includes(cycle.status);
};

const isAbleToPay = cycle =>
  isInPaymentStatus(cycle.status) &&
  isCycleOrdersOnPaymentStatus(cycle) &&
  isCycleOrdersEventsOnPaymentStatus(cycle);

const filterCycles = (cycles, field, values) =>
  cycles.filter(cycle => !values.includes(cycle[field]));

const sortByStartsAt = cycles =>
  cycles.sort((a, b) => moment(b.starts_at) - moment(a.starts_at));

const noticeOfPaymentTermLoss = account =>
  `Oi, sou usuário do app Donamaid, ${accountHelper.fullName(account)} - ${
    account.email
  }. Perdi o prazo para o pagamento do ciclo de assinatura e gostaria de retomá-la.`;

export default {
  getState,
  isAbleToPay,
  filterCycles,
  sortByStartsAt,
  isInPaymentStatus,
  noticeOfPaymentTermLoss,
  isConfirmed
};



// WEBPACK FOOTER //
// ./src/utils/states/cycle.js